import gql from 'graphql-tag';
import { getGraphQLClientForMultiSourceSkuWithToken } from 'utils/apiRequests';

//Below two are helper functions for fieldname errors for graphql 2.4.0
function lowercaseFirstChar(obj) {
	const newObj = {};
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];
			const newKey = key.charAt(0).toLowerCase() + key.slice(1);
			if (typeof value === 'object' && !Array.isArray(value)) {
				// Recursively lowercase first character of field names of nested objects
				newObj[newKey] = lowercaseFirstChar(value);
			} else {
				newObj[newKey] = value;
			}
		}
	}

	// Remove the "filterTo" and "dateTo" property if it exists
	delete newObj.filterTo;
	delete newObj.dateTo;

	return newObj;
}

const multiSourceSkuQuery = (request, columns) => {
	const fields = columns.map(col => col.field);
	const rowGroupsData = columns.map((item, index) => {
		return {
			id: index + 1,
			displayName: item.headerName,
			field: item.field,
			selector: 'a',
		};
	});
	return {
		query: gql`
			query getSKUData(
				$start: Int!
				$end: Int!
				$sortModel: [SortModelType!]
				$filterModel: [FilterModelTypeV2!]
				$rowGroups:[RowGroupModelType!]
		  	$groupCols:[GroupColsModelType!]
		  	$havingModel:[HavingModelType!]
				$valueCols:[ValueColsModelType!]
				$joinModel: [JoinModelType!]
				$caseModel:[CaseModelType!]
				$primaryTable: String!
			) {
				getSKUData(
					startRow: $start
					endRow: $end
					sorting: $sortModel
					filterModel: $filterModel
					rowGroups: $rowGroups
					groupCols: $groupCols
					havingModel: $havingModel
					valueCols: $valueCols
					joinModel: $joinModel
					primaryTable: $primaryTable
					caseModel:$caseModel
				) {
					${[...fields]}
				}
			}
		`,
		variables: {
			start: request.startRow,
			end: request.endRow,
			sortModel: request.sortModel,
			filterModel: [lowercaseFirstChar(request.filterModel)],
			rowGroups: rowGroupsData,
			groupCols: [],
			havingModel: [],
			valueCols: [],
			joinModel: [],
			caseModel: [],
			primaryTable: '[sxr].[SKU_analysis] a',
		},
	};
};

//this function makes columns from the data
const ServerSideDataSource = gridOptions => {
	return {
		// called by the grid when more rows are required
		getRows: async params => {
			const object = {};
			object.gridOptions = gridOptions;
			object.client = await getGraphQLClientForMultiSourceSkuWithToken();
			const columns = object.gridOptions.columnDefs;

			object.client
				.query(multiSourceSkuQuery(params.request, columns))
				.then(response => {
					let rows = response.data.getSKUData;
					let lastRow = -1;
					if (rows.length <= gridOptions.cacheBlockSize) {
						lastRow = params.request.startRow + rows.length;
					}
					params.successCallback(rows, lastRow);
				})
				.catch(err => {
					console.error(err);
					params.failCallback();
				});
		},
	};
};

export default ServerSideDataSource;
